<template>
  <span class="icon">
    <img
      v-if="customIcon"
      :src="customIcon"
      :style="{ width: imageSize }"
      :aria-hidden="ariaHidden"
      :alt="label"
      class="custom-icon"
    >
    <v-icon
      v-else
      :color="color"
      :size="size"
      :aria-label="label"
      :aria-hidden="ariaHidden"
      :role="role"
      class="default-icon"
    >
      {{ defaultIcon }}
    </v-icon>
  </span>
</template>

<script>
// Default icon names can be taken from https://materialdesignicons.com/
export default {
  props: {
    defaultIconName: {
      type: String,
      required: true,
    },
    customIcon: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 24,
    },
    label: {
      type: String,
      default: '',
    },
    ariaHidden: {
      type: Boolean,
      default: false,
    },
    role: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      defaultIcon: null,
    }
  },
  computed: {
    imageSize() {
      return `${this.size}px`
    }
  },
  async created() {
    if (!this.customIcon) {
      try {
        const {[this.defaultIconName]: icon} = await import('@mdi/js');
        this.defaultIcon = icon;
      } catch (error) {
        console.log('Icon could not be loaded', error);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  img {
    height: auto;
  }
}
</style>
